import axios from 'axios'
import { serializeParams } from '../utils/genericUtils.js'

export default {
  namespaced: true,

  actions: {
    getStudentsAttendanceCount(_, params) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/studentScheduleAttendance/statistics${serializeParams(params)}`,
        method: 'GET',
      })
    },
    getStudentsAttendance(_, params) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/studentScheduleAttendance${serializeParams(params)}`,
        method: 'GET',
      })
    },
    getStudentsAttendanceXlsx(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/studentScheduleAttendance/report/xlsx${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getStudentsAttendancePdf(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/studentScheduleAttendance/report/pdf${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    /**
     * @typedef {{type: "ON_TIME"|"LATE, ON_TIME" | "ABSENCE"}} Type
     * @param {*} _
     * @param {{id_schedule_attendance: number, body: Type}} data
     * @returns
     */
    editStudentsAttendance(_, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/studentScheduleAttendance/${data.id_schedule_attendance}/type`,
        method: 'PUT',
        data: data.body,
      })
    },
    getAttendancebyDate(ó, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/attendance/web/report?date=' + obj,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getAttendance({ rootGetters }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/attendance/web/reportbydate?id=' +
            rootGetters.getBranch.id,
          data: obj,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getOuts({ rootGetters }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/attendance/web/reportoutbydate?id=' +
            rootGetters.getBranch.id,
          data: obj,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getDelivers({ rootGetters }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/request/web/deliverReports',
          data: obj,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getStudentEntriesReport({ rootGetters }, params) {
      const querystring = require('querystring')
      const myurl = querystring.stringify(params)
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/entries/report?' + myurl,
          method: 'GET',
          //params: params,
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getParentEntriesReport({ rootGetters }, params) {
      const querystring = require('querystring')
      const myurl = querystring.stringify(params)
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/entries/report/parents?' + myurl,
          method: 'GET',
          //params: params,
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getCollaboratorEntriesReport({ rootGetters }, params) {
      const querystring = require('querystring')
      const myurl = querystring.stringify(params)
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL + '/entries/report/collaborators?' + myurl,
          method: 'GET',
          //params: params,
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getVisitEntriesReport({ rootGetters }, params) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/entries/report/visits',
          method: 'GET',
          params: params,
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getFilters() {
      return axios({
        url: `${process.env.VUE_APP_URL}/request/web/deliveriesReport/filters`,
        method: 'GET',
      })
    },
    getStudentsOutingsReport({ rootGetters }, params) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/request/web/deliveriesReport${serializeParams(params)}`,
        method: 'GET',
      })
    },
    getTempsCollaborator() {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/entries/report/collaborators/availableTemperatures',
          method: 'GET',
        })
          .then((response) => {
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getTempsStudents() {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL + '/entries/report/availableTemperatures',
          method: 'GET',
        })
          .then((response) => {
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getTempsParents() {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/entries/report/parents/availableTemperatures',
          method: 'GET',
        })
          .then((response) => {
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getTempsAll() {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/entries/report/all/availableTemperatures',
          method: 'GET',
        })
          .then((response) => {
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getStudentEntriesReportAll({ rootGetters }, params) {
      return axios({
        url: `${process.env.VUE_APP_URL}/entries/report/all${serializeParams(
          params
        )}`,
        method: 'GET',
      })
    },

    getStudentsParentsByBranchToCsv(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `
            ${
              process.env.VUE_APP_URL
            }/student/web/exportStudentWithParent${serializeParams(filters)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getAllReportAllIngresoPDF(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/entries/report/downloadpdf${serializeParams(filters)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getAllReportAllIngresoEX(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/entries/report/downloadxls${serializeParams(filters)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getGraphValors({ rootGetters }, params) {
      const querystring = require('querystring')
      const queryparams = querystring.stringify(params)
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/entries/report/statistics?' +
            queryparams,
          method: 'GET',
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getGraphValorsAforo({ rootGetters }, params) {
      const querystring = require('querystring')
      const queryparams = querystring.stringify(params)
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/entries/report/capacity/statistics?' +
            queryparams,
          method: 'GET',
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getEntriesAforo({ rootGetters }, params) {
      const querystring = require('querystring')
      const queryparams = querystring.stringify(params)
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/entries/report/capacity/all?' +
            queryparams,
          method: 'GET',
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getAforoReportPDF({ rootGetters }, filters) {
      axios.defaults.headers.common['Accept'] = 'application/octet-stream'
      axios.defaults.headers.common['Content-Type'] = 'application/octet-stream'
      const querystring = require('querystring')
      const queryparams = querystring.stringify(filters)
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/entries/report/capacity/pdf?' +
            queryparams,
          method: 'GET',
          responseType: 'blob',
        })
          .then((response) => {
            delete axios.defaults.headers.common['Accept']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Accept'] = 'application/json'
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            delete axios.defaults.headers.common['Accept']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Accept'] = 'application/json'
            reject(error)
          })
      })
    },

    getAforoReportEX({ rootGetters }, filters) {
      axios.defaults.headers.common['Accept'] = 'application/octet-stream'
      axios.defaults.headers.common['Content-Type'] = 'application/octet-stream'
      const querystring = require('querystring')
      const queryparams = querystring.stringify(filters)
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/entries/report/capacity/xlsx?' +
            queryparams,
          method: 'GET',
          responseType: 'blob',
        })
          .then((response) => {
            delete axios.defaults.headers.common['Accept']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Accept'] = 'application/json'
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            delete axios.defaults.headers.common['Accept']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Accept'] = 'application/json'
            reject(error)
          })
      })
    },

    getAllReportAllWorkShopXLS({ rootGetters }, filters) {
      axios.defaults.headers.common['Accept'] = 'application/octet-stream'
      axios.defaults.headers.common['Content-Type'] = 'application/octet-stream'
      const querystring = require('querystring')
      const queryparams = querystring.stringify(filters)
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/entries/report/CourseAttendance/xlsx?' +
            queryparams,
          method: 'GET',
          responseType: 'blob',
        })
          .then((response) => {
            delete axios.defaults.headers.common['Accept']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Accept'] = 'application/json'
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            delete axios.defaults.headers.common['Accept']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Accept'] = 'application/json'
            reject(error)
          })
      })
    },
    getConfirmParentsInfo({ rootGetters }, idNotice) {
      axios.defaults.headers.common['Accept'] = 'application/octet-stream'
      axios.defaults.headers.common['Content-Type'] = 'application/octet-stream'
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/notice/receivedbyparents/report/xlsx?id=' +
            idNotice,
          method: 'GET',
          responseType: 'blob',
        })
          .then((response) => {
            delete axios.defaults.headers.common['Accept']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Accept'] = 'application/json'
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            delete axios.defaults.headers.common['Accept']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Accept'] = 'application/json'
            reject(error)
          })
      })
    },
    reportsByLevel(context, params) {
      return axios({
        url:
          process.env.VUE_APP_URL + '/studentScheduleAttendance/report/levels',
        method: 'GET',
        params,
      })
    },
    getReportSettings(_, params) {
      return axios({
        url: `${process.env.VUE_APP_URL}/automaticReportSetting`,
        method: 'GET',
        params,
      })
    },
    createReportSettings(_, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/automaticReportSetting`,
        method: 'POST',
        data,
      })
    },
    editReportSettings(_, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/automaticReportSetting`,
        method: 'PUT',
        data,
      })
    },
    getThirdQrReport(_, params) {
      return axios({
        url: `${process.env.VUE_APP_URL}/thirdQR${serializeParams(params)}`,
        method: 'GET',
      })
    },
    getThirdQrPdf(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/thirdQR/pdf${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getThirdQrXlsx(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/thirdQR/web/qr/today/xlsx`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getThirdQrTodayXlsx(_) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/thirdQR/web/qr/today/xlsx`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    addNote(_, { idAttendance, data }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/studentScheduleAttendance/${idAttendance}/notes`,
        method: 'POST',
        data,
      })
    },
    editNote(_, { idAttendance, data }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/studentScheduleAttendance/${idAttendance}/notes`,
        method: 'PUT',
        data,
      })
    },
    deleteNote(_, idAttendance) {
      return axios({
        url: `${process.env.VUE_APP_URL}/studentScheduleAttendance/${idAttendance}/notes`,
        method: 'DELETE',
      })
    },
    getStudentsOutingsXlsx(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/request/web/deliveriesReport/xlsx${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getStudentsOutingsPdf(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/request/web/deliveriesReport/pdf${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
  },
}
